import styled from 'styled-components'

export default styled.div`
  overflow: auto;
  
  header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: sticky;
    top: 0;
  }

  .search-container {
    width: 100%;
    position: relative;
    display: flex;

    .search-icon {
      position: absolute;
      top: 0px;
      z-index: 1;
      padding: 10px;
      img {
        filter: brightness(0);
      }
    }
  }

  .close-container img,
  .search-icon img {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  .content {
    overflow: auto;
  }
`